document.addEventListener('DOMContentLoaded', function(){
	setPullDown();
});

const setPullDown =()=>{
	const wrap=document.querySelectorAll(".pullSet li");
	wrap.forEach((li)=>{
		const bt=li.querySelector("h4");
		//const pl=li.target.querySelector(".body");
		bt.addEventListener("click",(e)=>{
			//const act=document.querySelectorAll(".pullSet li.active");
			if(li.classList.contains("active")){
				li.classList.remove("active");
			}else{
				/*
				act.forEach((a)=>{
					a.classList.remove("active");
				});
				*/
				li.classList.add("active");
			}
			
		});
	});
}